export const sidebarStyles = {
    drawer: {
        width: 220,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
            width: 220,
            boxSizing: 'border-box',
            backgroundColor: '#FAFAFA',
            color: '#757677',


        },
        '& .Mui-selected': {
            color: 'red',
        }
    },
    icons: {
        color: '#757677',
        marginLeft: '0px',
        padding: '6px 16px',
        paddingRight: '26px',
    },
    text: {
        '& span': {
            marginLeft: '-20px',
            fontWeight: '600',
            fontSize: '16px'
        }
    }

}